import './styles.scss'

import React, { useEffect, useState } from 'react'

import { apiPayment } from 'api'
import InfoHeaderPayment from '../../Common/InfoHeaderPayment'
import { I18n } from 'react-redux-i18n'
import { Button, TextNumberFormat } from 'components/Form'

const RefundPayment = (props) => {
  const { userId, orderId } = props 

  const [disabled, setDisabled] = useState(false)
  const [orderInfo, setOrderInfo] = useState({})
  const [orderError, setOrderError] = useState('')
  const [priceRefund, setPriceRefund] = useState(0)
  const [error, setError] = useState('')

  useEffect(() => {
    getOrder()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  const getOrder = async () => {
    try{
      const order = await apiPayment.getOrderId({ userId, orderId })
      setOrderInfo(order.data)
      setPriceRefund(order.data.priceLeft)
      setDisabled(order.data.total === order.data.totalRefund)
    } catch (error) {
      setOrderError(I18n.t('message_error_data_list_distribution'))
    }
  }

  const onRefund = async () => {
    if (priceRefund === 0 || !priceRefund) {
      setError('plugins-refund-noPriceRefund')
      return
    }

    if (priceRefund > orderInfo.priceLeft) {
      setError('plugins-refund-PriceRefund-error-valueMax')
      return
    }

    setDisabled(true)

    try {
      const amount = parseFloat(priceRefund.toFixed(2))

      await apiPayment.postRefund({
        orderId: orderId,
        orderNumber: orderInfo.orderNumber,
        amount
      })
      setError('')
      getOrder()
    } catch(error) {
      setError('dashboard_payment_error_refund')
      setDisabled(false)
    }
  }

  return (
    <div>
      <InfoHeaderPayment amount={orderInfo.total || 0} date={orderInfo.date || ''} currency={orderInfo.currency} />
      <div className='resources-container-orders'>
        <div className='refund-input'>

          <div>
            <label className='labelTextRefund mb-2'>
              {I18n.t('plugins_refund_payment_label_cant')}
            </label>
            <div className='formGroupPrice'>
              <TextNumberFormat
                defaultValue={priceRefund}
                value={priceRefund}
                id='priceRefund'
                name='priceRefund'
                onChange={(value) => setPriceRefund(value)}
                className={'new-input price plugin-payment__input'}
                invalid={priceRefund > orderInfo.total}
                disabled={orderInfo.total === orderInfo.totalRefund || disabled}
              />
              <span className='input-group-text wrapper-icon-euro-price'>
                <i className='fa fa-eur'></i>
              </span>
            </div>
          </div>
          <div  className='orderPaymentMax'>
            <div
              className='subText'
            >
              {I18n.t('plugins_refund_payment_max_cant_text')} {orderInfo.priceLeft? orderInfo.priceLeft.toFixed(2):0} <i className='fa fa-eur'></i>
            </div>
          </div>
        </div>
        {error !== '' &&
            <div >
              <span className='text-danger'>{I18n.t(error)}</span>
            </div>}
        {orderError.length>0&&
          <div >
            <span className='text-danger'>{orderError}</span>
          </div>}
        <div style={{ marginTop: '1.5rem', width:'60%' }}>
          <Button
            secondary
            onClick={onRefund}
            className='buttonCreateNewPaymentLink'
            disabled={orderInfo.total === orderInfo.totalRefund || disabled}
          >
            {I18n.t('plugins_payment_refundPayment')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RefundPayment
